'use client';

import React from 'react'
import Image from 'next/image';

// Hooks
import useClient from '@hooks/useClient';

// Components
import { Header } from "../../components/century-21-page"
import { Form, InfoContact } from "./_components"

// Assets
import Vector from "@public/png/vector-bg-1.png"
import useWhatsappMessage from '@src/hooks/useWhatsapp';

const SocialMedia = ({ label, ...props }) => <a {...props} className="cursor-pointer text-13 underline font-sfpro-heavy mr-4 last:mr-0 
dd-sm:mb-6 dd-sm:mb-0">{label}</a>

const Page = () => {
  const { sendMessage } = useWhatsappMessage();

  const handleSendMessage = (type = "button") => {
    if (type === "anchor") {
      return sendMessage({
        phone: "+6285211627223",
        type,
        message: "Halo CENTURY 21 Indonesia"
      })
    }

    sendMessage({
      phone: "+6285211627223",
      type,
      message: "Halo CENTURY 21 Indonesia"
    })
  }

  return (
    <div>
      <Header />
      <div className='main-wrapper bg-white-3 relative min-h-[calc(100vh-66px-73px)] pt-[64px] pb-[56px]'>
        <Image
          src={Vector}
          alt='Vectors'
          width="auto"
          height="auto"
          className='absolute w-full h-full top-0 left-0 object-cover'
        />
        <div className='content-wrapper flex flex-col justify-between min-h-full relative z-[2]'>
          <div className='grid grid-cols-2 gap-x-[80px] w-full h-full 
          dd-lg:block'>
            <div className='flex flex-col h-full justify-between'>
              <InfoContact />
              <div className='flex 
              dd-lg:justify-between dd-lg:mt-[40px]'>
                <SocialMedia label="INSTAGRAM" href="https://www.instagram.com/century21indonesia?igsh=bms1MzVzZTV3cXNi" />
                <SocialMedia label="FACEBOOK" href="https://www.facebook.com/century21indonesia" />
                <SocialMedia label="YOUTUBE" href="https://www.youtube.com/@century21indonesia" />
                <SocialMedia label="WHATSAPP" href={handleSendMessage("anchor")} />
              </div>
            </div>
            <div className='hidden my-[40px] w-full h-[1px] border-b-[0.5px] border-solid border-grey-0 
              dd-lg:block' />
            <Form />
          </div>
        </div>

      </div>
      <div className='main-wrapper py-6 border-t border-solid border-grey-0 bg-white-3'>
        <div className='content-wrapper flex items-center justify-between 
        dd-lg:block'>
          <p className=' text-13 dd-lg:mb-2'>Designed by CENTURY 21 Indonesia</p>
          <p className=' text-13'>© 2024 CENTURY 21 Indonesia. All Rights Reserved.</p>
        </div>
      </div>
    </div>
  )
}

export default function ContactClient() {
  const isClient = useClient()

  if (!isClient) return null;
  return <Page />
}
